import Accordion from "./Accordion";
import styles from "./FormContainer.module.scss";
// import InputTitle from "./InputTitle";

function FormContainer() {
  return (
    <div className={styles.maincontainer}>
      <Accordion />
    </div>
  );
}

export default FormContainer;
